interface ShotInsertZoneProps {
  title: string;
  onClick: () => void;
}

export default function ShotInsertZone({ title, onClick }: ShotInsertZoneProps) {
  return (
    <div
      className="shot-insert-zone"
      onClick={onClick}
      title={title}
    >
      <div className="shot-insert-line" />
      <div className="shot-insert-btn">+</div>
      <div className="shot-insert-line" />
    </div>
  );
}
